export default {
  order: 5,
  layerGroupId: 'GROUP_LCD',
  dataLayer: {
    id: 'GLAD_ALERTS',
    order: 5,
    type: 'remoteDataLayer',
    uuid: '356f862b-3e70-493a-997b-dc2a193410e9',
    groupId: 'GROUP_LCD',
  },
  layer: {
    metadata: {
      metadata: null,
      legendConfig: {
        name: {
          ka: 'GLAD შეტყობინებები',
          zh: 'GLAD 预警',
          id: 'Peringatan GLAD',
          pt: 'Alertas GLAD',
          es: 'Alertas GLAD',
          fr: 'Alertes GLAD',
          en: 'GLAD Alerts',
        },
        type: 'basic',
        items: [
          {
            outlineColor: '#555555',
            color: '#DC6699',
            name: {
              ka: 'GLAD შეტყობინებები',
              zh: 'GLAD 预警',
              id: 'Peringatan GLAD',
              pt: 'Alertas GLAD',
              es: 'Alertas GLAD',
              fr: 'Alertes GLAD',
              en: 'GLAD Alerts',
            },
          },
          {
            outlineColor: '#555555',
            color: '#e4c600',
            name: {
              ka: 'ბოლო შეტყობინებები',
              zh: '最近的提醒',
              id: 'Lansiran Terbaru',
              pt: 'Alertas Recentes',
              es: 'Alertas recientes',
              fr: 'Alertes récentes',
              en: 'Recent Alerts',
            },
          },
        ],
      },
      interactionConfig: {},
    },
    sublabel: {
      ka: '(ყოველკვირეული, 30მ, აარჩიეთ ქვეყნები, UMD/ GLAD)',
      zh: '（每周，30m，热带地区，UMD/ GLAD）',
      id: '(mingguan, 30m, tropis. UMD/GLAD)',
      pt: '(semanal, 30m, trópicos, UMD/ GLAD)',
      es: '(semanal, 30m, trópicos, UMD/ GLAD)',
      fr: '(hebdomadaire, 30m, tropiques, UMD/ GLAD)',
      en: '(weekly, 30m, tropics, UMD/ GLAD)',
    },
    label: {
      ka: 'GLAD შეტყობინებები',
      zh: 'GLAD 预警',
      id: 'Peringatan GLAD',
      pt: 'Alertas GLAD',
      es: 'Alertas GLAD',
      fr: 'Alertes GLAD',
      en: 'GLAD Alerts',
    },
    confidence: [0, 1],
    maxDateValue: 999999,
    minDateValue: 15000,
    technicalName: 'umd_landsat_alerts',
    url: 'https://tiles.globalforestwatch.org/umd_glad_landsat_alerts/latest/default/{z}/{x}/{y}.png',
    type: 'glad',
    id: 'GLAD_ALERTS',
  },
  isMetadataError: false,
  isError: false,
};
